/* import __COLOCATED_TEMPLATE__ from './nensa-classes-creator.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class NensaClassesCreatorComponent extends Component
{
	@service store;

	@tracked modifier = '';
	@tracked selectedGenders = { M: false, F: false, X: false };
	@tracked selectedClasses = {
		U14: false, U16: false, U18: false, U20: false, U23: false, SR: false,
		M1: false, M2: false, M3: false, M4: false, M5: false, M6: false,
		M7: false, M8: false, M9: false, M10: false, M11: false
	};

	ageClasses = ['U14', 'U16', 'U18', 'U20', 'U23', 'SR',
	              'M1', 'M2', 'M3', 'M4', 'M5', 'M6',
	              'M7', 'M8', 'M9', 'M10', 'M11'];

	genders = [
		{ display: 'Male', internal: 'M' },
		{ display: 'Female', internal: 'F' },
		{ display: 'Non-Binary', internal: 'X' }
	];

	@action
	toggleGender(genderKey, browserEvent)
	{
		this.selectedGenders = {
			...this.selectedGenders,
			[genderKey]: browserEvent.target.checked
		};
	}

	@action
	toggleClass(ageClass, browserEvent)
	{
		this.selectedClasses = {
			...this.selectedClasses,
			[ageClass]: browserEvent.target.checked
		};
	}

	@action
	async createClasses()
	{
		var event = this.args.event;
		var store = this.store;
		var modifier = this.modifier;

		// Get selected genders and classes
		var selectedGenderKeys = Object.keys(this.selectedGenders).filter(k => this.selectedGenders[k]);
		var selectedClassKeys = Object.keys(this.selectedClasses).filter(k => this.selectedClasses[k]);

		if (selectedGenderKeys.length === 0 || selectedClassKeys.length === 0) {
			return;
		}

		// Get existing classes for this event
		var existingClasses = await event.get('classes');

		// Create classes for each combination of gender and age class
		for (const genderKey of selectedGenderKeys) {
			var gender = this.genders.find(g => g.internal === genderKey);

			for (const ageClass of selectedClassKeys) {
				var className = modifier ? `${ageClass}*${modifier}` : ageClass;

				// Check if class with same name and gender already exists
				var existingClass = existingClasses.find(c =>
					c.name === className && c.gender === gender.internal
				);

				if (existingClass) {
					// Skip if class already exists
					continue;
				}

				var newClass = store.createRecord('class', {
					name: className,
					gender: gender.internal,
					EventId: event
				});
				await newClass.save();
			}
		}
	}
}
